import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus, faL } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import FAQs from "./settings/FAQs";

import StartScreens from "./settings/StartScreens";

ModuleRegistry.registerModules([ClientSideRowModelModule]);

const Settings = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);

    var settingsarr = [
        {title: "Start Screens", isactive: true},
        {title: "FAQs", isactive: false},
    ];

    const [selectedtab, setselectedtab] = useState("Start Screens");

    const handlechangetab = (title) => {
        setselectedtab(title);
    }
  
    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
            //   fetchallcourses();
            } else {
              navigate("/admin/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">

        <div className="settingsdiv mt-2">
            {
                settingsarr?.length > 0 ?
                settingsarr?.map((item, index) => {
                    return (
                      <div className={
                        selectedtab == item?.title ?
                        "settingbtndiv active" : "settingbtndiv"
                        } key={index}
                        onClick={() => {handlechangetab(item?.title)}}
                        >
                        <p>{item?.title}</p>
                      </div>
                    );
                }) : null
            }
            
        </div>

        <div className="settingtablediv">
            {
                selectedtab == 'Start Screens' ?
                <StartScreens /> :
                selectedtab == 'FAQs' ?
                <FAQs /> :
                null
            }
        </div>

      </div>
    );
}

export default Settings
